import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
var REQUEST_KEY = "quotePriceUpdate";
export var useQuotePrice = function (setSeeToast, onSuccess) {
    var dispatch = useDispatch();
    var t = useTranslation().t;
    var quotePriceData = useSelector(function (s) { var _a, _b, _c; return (_c = (_b = (_a = s.CustomRequest) === null || _a === void 0 ? void 0 : _a.dataCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var quotePriceLoading = useSelector(function (s) { var _a, _b, _c; return (_c = (_b = (_a = s.CustomRequest) === null || _a === void 0 ? void 0 : _a.loadingCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : false; });
    var quotePriceError = useSelector(function (s) { var _a, _b, _c; return (_c = (_b = (_a = s.CustomRequest) === null || _a === void 0 ? void 0 : _a.errorCustomRequest) === null || _b === void 0 ? void 0 : _b[REQUEST_KEY]) !== null && _c !== void 0 ? _c : null; });
    var updateQuotePrice = function (quoteId, premium) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "PATCH",
            path: "/asg/Api/V1/Quote/".concat(quoteId, "/Price"),
            body: {
                amount: String(premium),
                currencySymbol: "RD$",
            },
        }));
    };
    useEffect(function () {
        if (quotePriceData) {
            dispatch(clearCustomRequest(REQUEST_KEY));
            onSuccess();
        }
    }, [quotePriceData]);
    useEffect(function () {
        if (quotePriceError) {
            showErrorToast(quotePriceError, setSeeToast, t, true);
            dispatch(clearCustomRequest(REQUEST_KEY));
        }
    }, [quotePriceError]);
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return { updateQuotePrice: updateQuotePrice, quotePriceData: quotePriceData, quotePriceLoading: quotePriceLoading };
};
